import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockVideoComponent } from '@app/components/blocks/block-video/block-video.component';
import { VideoModule } from '@app/components/video/video.module';

@NgModule({
  imports: [CommonModule, SharedModule, VideoModule],
  declarations: [BlockVideoComponent],
  exports: [BlockVideoComponent],
})
export class BlockVideoModule {}
